let BASE_URL = "/api/v2";


function handleSessionExpired(response) {
  if (response.status !== 401) return;
  if (!window.location.pathname.startsWith("/refresh")) {
    const redirect = window.location.pathname + window.location.search;
    window.location.href = "/refresh?redirect=" + encodeURIComponent(redirect);
  }
  throw new Error("Session expired, refreshing login");
}

function dictToURI(dict) {
  var str = [];
  for (var p in dict) {
    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(dict[p]));
  }
  return str.join("&");
}

var FleetWebApi = {
  async getNetSuiteFromMfgWeb(orderNumber, token) {
    const url =
      "https://mfgweb.alertlabs.com/api/v2/shipping/name/" + orderNumber;
    let response = await fetch(url, {
      method: "GET",
      headers: {
        token: token,
      },
    });
    if (response.ok) {
      response = await response.json();
      const orderID = response.response.order.order_id;
      const deviceURL = BASE_URL + "/netsuite/" + orderID + "/devices";
      const r = await this.getNetworkItem(deviceURL);
      return r.response;
    } else {
      throw new Error(response.statusText);
    }
  },

  async getDevicesOnShopifyOrder(shopifyOrder) {
    const url = BASE_URL + "/shopify/" + shopifyOrder + "/devices";

    const response = await this.getNetworkItem(url);
    return response.response;
  },
  async getDevicesOnChargifyOrder(chargifyOrder) {
    const url = BASE_URL + "/chargify/" + chargifyOrder + "/devices";

    const response = await this.getNetworkItem(url);
    return response.response;
  },
  async getShopifyOrderDetails(shopifyOrder, token) {
    const url = "https://mfgweb.alertlabs.com/api/v2/shopify/" + shopifyOrder;
    let response = await fetch(url, {
      method: "GET",
      headers: {
        token: token,
      },
    });
    if (response.ok) {
      response = await response.json();
      return response.response;
    } else {
      throw new Error(response.statusText);
    }
  },

  async getRmaBySerial(serial, token) {
    const url = "https://mfgweb.alertlabs.com/api/v2/rma/device/" + serial;

    let response = await fetch(url, {
      method: "GET",
      headers: {
        token: token,
      },
    });
    if (response.ok) {
      response = await response.json();
      return response.response;
    } else {
      throw new Error(response.statusText);
    }
  },
  async getMfgWebNotesBySerial(serial, token) {
    const url = "https://mfgweb.alertlabs.com/api/v2/note/" + serial;

    let response = await fetch(url, {
      method: "GET",
      headers: {
        token: token,
      },
    });
    if (response.ok) {
      response = await response.json();
      return response.response;
    } else {
      throw new Error(response.statusText);
    }
  },


  async getLocationIDsByUserID(user) {
    const url = BASE_URL + "/domain/search/" + user + "/locations";

    const response = await this.getNetworkItem(url);

    return response;
  },


  async getDomainOwnerSearch(domain) {
    const url = BASE_URL + "/domain/search/owner/" + domain;
    const response = await this.getNetworkItem(url);

    return response;
  },

  async getDomainSearch(domain) {
    const url = BASE_URL + "/domain/search/" + domain;
    const response = await this.getNetworkItem(url);

    return response;
  },

  async getDomain(domain) {
    const url = BASE_URL + "/domain/" + domain;
    const response = await this.getNetworkItem(url);

    return response;
  },
  async getLocationSearch(location) {
    const url = BASE_URL + "/location/search/" + location;
    const response = await this.getNetworkItem(url);
    return response;
  },
  async getLocationData(locationIds) {
    const payload = locationIds;
    const url = BASE_URL + "/location/data";
    const response = await this.postNetworkItem(url, payload);
    return response;
  },
  async deleteUser(userId) {
    const url = BASE_URL + "/applicationuser/application/" + userId;

    const response = await this.deleteNetworkItem(url);

    return response;
  },

  async addUser(email) {
    const url = BASE_URL + "/applicationuser/application";

    const response = await this.postNetworkItem(url, { email: email });

    return response;
  },

  async getUsers(limit, skip) {
    const url =
      BASE_URL +
      "/applicationuser/application?limit=" +
      String(limit) +
      "&skip=" +
      String(skip);

    const response = await this.getNetworkItem(url);

    return response.response;
  },
  async getUser(userId) {
    const url = BASE_URL + "/applicationuser/application/" + userId;

    const response = await this.getNetworkItem(url);

    return response.response;
  },
  async patchUser(userId, field, fieldValue) {
    const url = BASE_URL + "/applicationuser/application/" + userId;

    const response = await this.patchNetworkItem(url, {
      fieldKey: field,
      value: fieldValue,
    });

    return response.result;
  },

  async getSensorsOnLocation(locationId) {
    const url = BASE_URL + "/fleet/location/" + locationId + "/sensors";

    const response = await this.getNetworkItem(url);

    return response.response;
  },

  async getSensorsOnLocationSummary(locationId) {
    const url = BASE_URL + "/location/" + locationId + "/sensors/summary";

    const response = await this.getNetworkItem(url);

    return response.response;
  },

  async getShuttieCommsReport(
    limit = 100,
    skip = 0,
    filter = {},
    serialNumberSearch,
    emailSearch
  ) {
    filter.limit = limit;
    filter.skip = skip;
    filter.serialNumberSearch = serialNumberSearch;
    filter.emailSearch = emailSearch;
    const url = BASE_URL + "/report/badshutties?" + dictToURI(filter);

    const response = await this.getNetworkItem(url);

    return response.response;
  },

  async setBadShuttieContacted(serial) {
    const url =
      BASE_URL + "/report/badshutties/contacted/" + serial;

    const response = await this.putNetworkItem(url);

    return response.result;
  },

  async setBadShuttieReceived(serial) {
    const url =
      BASE_URL + "/report/badshutties/rma/" + serial;

    const response = await this.putNetworkItem(url);

    return response.result;
  },

  async setBadShuttieReworked(serial) {
    const url =
      BASE_URL + "/report/badshutties/reworked/" + serial;

    const response = await this.putNetworkItem(url);

    return response.result;
  },
  async getBadShuttieReportSummary() {
    const url = BASE_URL + "/report/badshutties/summary";

    const response = await this.getNetworkItem(url);

    return response.response;
  },
  async getShuttieCleaningStatus() {
    const url = BASE_URL + "/report/shuttie/cleaningstatus";

    const response = await this.getNetworkItem(url);

    return response.response;
  },
  async getEventSpammerRepeatOffenders() {
    const url = BASE_URL + "/report/eventspammers/repeatoffenders";

    const response = await this.getNetworkItem(url);

    return response.response;
  },
  // useArchive: only true once the user has confirmed querying the online archive
  // (dates older than the archive cutoff are refused by the backend without it)
  async getReportByType(reportType, reportDate, useArchive = false) {
    const url =
      BASE_URL + "/report/type/" + reportType + "/" + reportDate +
      (useArchive ? "?use_archive=true" : "");

    const response = await this.getNetworkItem(url);

    return response.response;
  },
  async getFleetStatusReportTypesByDay(reportDate, useArchive = false) {
    const url =
      BASE_URL + "/report/fleetstatusreporttypes/" + reportDate +
      (useArchive ? "?use_archive=true" : "");
    const response = await this.getNetworkItem(url);

    return response.response;
  },
  async getOfflineFleetStatusReportTypesByDay(reportDate, useArchive = false) {
    const url =
      BASE_URL + "/report/fleetstatusreporttypes/offline/" + reportDate +
      (useArchive ? "?use_archive=true" : "");
    const response = await this.getNetworkItem(url);

    return response.response;
  },
  async getFleetStatusReportDeviceList(reportDate, reportType, arg, mode, useArchive = false) {
    const url = BASE_URL + "/report/fleetstatusreport/devicelist/" + mode;
    var payload;
    if (mode === "firmware") {
      const firmware = arg;
      payload = { reportDate, reportType, firmware, useArchive };
    } else {
      const rev = arg;
      payload = { reportDate, reportType, rev, useArchive };
    }

    const response = await this.postNetworkItem(url, payload);

    return response.response;
  },
  async getHarpieData(gatewayCoreId, sensorId, startDate, endDate) {
    const url = BASE_URL + "/harpie/query";

    const payload = { gatewayCoreId, sensorId, startDate, endDate };

    const response = await this.postNetworkItem(url, payload);

    return response.response;
  },
  async getHarpieWaveform(waveformId) {
    const url = BASE_URL + "/harpie/waveform/" + waveformId;

    const response = await this.getNetworkItem(url);

    return response.response;
  },
  async getFleetStatusReport(reportDate, reportType, useArchive = false) {
    const url = BASE_URL + "/report/fleetstatusreport";

    const payload = { reportDate, reportType, useArchive };

    const response = await this.postNetworkItem(url, payload);

    return response.response;
  },
  async getFleetStatusReportTimeline(reportType) {
    const url = BASE_URL + "/report/fleetstatusreport/timeline/" + reportType;

    const response = await this.getNetworkItem(url);

    return response.response;
  },
  async getSimDataUsage(limit, skip, sort, sortDir = "desc", weekOffset = 0, useArchive = false) {
    const url =
      BASE_URL +
      "/fleet/sim/data/summary?limit=" +
      String(limit) +
      "&skip=" +
      String(skip) +
      "&sort=" +
      sort +
      "&sort_dir=" +
      sortDir +
      "&week_offset=" +
      String(weekOffset) +
      (useArchive ? "&use_archive=true" : "");

    const response = await this.getNetworkItem(url);

    return response.response;
  },
  async simStateChange(serials, action, user, note) {
    const url = BASE_URL + "/particle/sims/statechange";

    const payload = { serials, user, note, action };

    const response = await this.postNetworkItem(url, payload);

    return response.response;
  },
  async getUserDetails(userId) {
    const url = BASE_URL + "/user/" + userId;

    const response = await this.getNetworkItem(url);

    return response.response;
  },
  async getReworkData(startDate, endDate, popCode, popRev) {
    const url = BASE_URL + "/rework/report/";

    const payload = { startDate, endDate, popCode, popRev };

    const response = await this.postNetworkItem(url, payload);

    return response.response;
  },
  async copyStationConfig(from, to) {
    const url = BASE_URL + "/station/copy/" + from + "/to/" + to;

    const response = await this.getNetworkItem(url);

    return response.result;
  },
  async restoreStationConfig(config_id) {
    const url = BASE_URL + "/config/history/" + config_id + "/restore";

    const response = await this.getNetworkItem(url);

    return response.result;
  },
  async getUserReport(al) {
    const url = BASE_URL + "/report/users?emails=" + String(al);
    const response = await this.getNetworkItem(url);
    return response.response;
  },
  async getProxies(coreId, device_type) {
    const url = BASE_URL + "/fleet/proxy/" + coreId + "/" + device_type;

    const response = await this.getNetworkItem(url);

    return response.response;
  },
  async getProductSlug(coreId) {
    const url = BASE_URL + "/device/productslug/" + coreId;

    const response = await this.getNetworkItem(url);

    return response.response;
  },
  async addDevice(
    coreId,
    platformType,
    hardwareRevision,
    radioTechnology,
    popSerial,
    particleProduct
  ) {
    const url = BASE_URL + "/device/";

    const payload = {
      coreId: coreId,
      platformType: platformType,
      hardwareRevision: hardwareRevision,
      radioTechnology: radioTechnology,
      popSerial: popSerial,
      particleProduct: particleProduct,
    };

    const response = await this.postNetworkItem(url, payload);

    return response.result;
  },
  async getStationConfig(name) {
    const url = BASE_URL + "/station/" + name;

    const response = await this.getNetworkItem(url);

    return response.response;
  },
  async getStationConfigs(limit = 20, skip = 0) {
    const url =
      BASE_URL + "/station/?skip=" + String(skip) + "&limit=" + String(limit);

    const response = await this.getNetworkItem(url);

    return response.response;
  },
  async getDeviceCoreID(lookupId) {
    const url = BASE_URL + "/device/getcoreid/" + lookupId;

    const response = await this.getNetworkItem(url);
    return response.response;
  },
  async getDeviceDetails(deviceSerial) {
    const url = BASE_URL + "/device/" + deviceSerial;

    const response = await this.getNetworkItem(url);
    return response.response;
  },
  async getDeviceFirmwareDetails(coreID, virtualID = null) {
    let url = BASE_URL + "/device/" + coreID + "/firmware";
    if (virtualID) {
      url += "?virtual_id=" + encodeURIComponent(virtualID);
    }

    const response = await this.getNetworkItem(url);

    return response.response;
  },
  async getCompanionConnectionSummary(coreID, startTime, endTime) {
    const payload = {
      startDate: startTime,
      endDate: endTime,
    };
    const url = BASE_URL + "/device/connection/companion/" + coreID;
    const response = await this.postNetworkItem(url, payload);
    return response.response;
  },
  async getCellConnectionSummary(coreID, startTime, endTime) {
    const payload = {
      startDate: startTime,
      endDate: endTime,
    };
    const url = BASE_URL + "/device/connection/cellular/" + coreID;
    const response = await this.postNetworkItem(url, payload);
    return response.response;
  },
  async getDeviceWaterData(
    coreID,
    startTime,
    endTime,
    windowSize,
    graphType,
    ratioVal,
    showReboots = false,
    showMetadata = false,
    virtualId = null
  ) {
    const url = BASE_URL + "/device/" + coreID + "/waterData";
    const payload = {
      startDate: startTime,
      endDate: endTime,
      windowSize: windowSize,
      graphType: graphType,
      ratioVal: ratioVal,
      showReboots: showReboots,
      showMetadata: showMetadata,
      metadataParams: {
        startDate: startTime,
        endDate: endTime,
        windowSize: windowSize,
        graphType: graphType,
      }
    };
    
    // Add virtualId to payload if provided
    if (virtualId) {
      payload.virtualId = virtualId;
    }
    
    const response = await this.postNetworkItem(url, payload);

    return response.response;
  },
  async getDeviceMetaData(coreID, device_type) {
    const url = BASE_URL + "/fleet/water/meta/" + coreID + "/" + device_type;

    const response = await this.getNetworkItem(url);

    return response.response;
  },
  async getDeviceLastHeard(coreID) {
    const url = BASE_URL + "/device/" + coreID + "/lastheard";

    const response = await this.getNetworkItem(url);

    return response.response;
  },
  async getLastCleaningCycle(coreID) {
    const url = BASE_URL + "/device/" + coreID + "/lastcleaningcycle";

    const response = await this.getNetworkItem(url);

    return response.response;
  },
  async getRebootData(coreID, limit = 1) {
    const url = BASE_URL + "/device/" + coreID + "/reboot?limit=" + limit;

    const response = await this.getNetworkItem(url);

    return response.response;
  },
  async getActiveConfigurations(coreID) {
    const url = BASE_URL + "/device/" + coreID + "/activeconfigs";

    const response = await this.getNetworkItem(url);

    return response.response;
  },
  async getRadioDataFromCoreId(coreId, startTime, endTime, productType = null, xAxis = "timestamp") {
    const payload = {
      startDate: startTime,
      endDate: endTime,
      xAxis: xAxis,
    };

    let url = BASE_URL + "/fleet/radio/cell/" + coreId;
    if (productType) {
      url += "?product_type=" + encodeURIComponent(productType);
    }

    const response = await this.postNetworkItem(url, payload);

    return response.response;
  },
  async getCompanionRadioDataFromCoreId(coreId, startTime, endTime, xAxis, productType = null) {
    const payload = {
      startDate: startTime,
      endDate: endTime,
      xAxis: xAxis,
    };

    let url = BASE_URL + "/fleet/radio/companion/" + coreId;
    if (productType) {
      url += "?product_type=" + encodeURIComponent(productType);
    }

    const response = await this.postNetworkItem(url, payload);

    return response.response;
  },
  async getCheckinData(coreId, startTime, endTime, deviceType = "cell", productType = null) {
    const payload = {
      startDate: startTime,
      endDate: endTime,
    };

    let url =
      BASE_URL +
      "/fleet/checkins/" +
      coreId +
      "?device_type=" +
      encodeURIComponent(deviceType);

    if (productType) {
      url += "&product_type=" + encodeURIComponent(productType);
    }

    const response = await this.postNetworkItem(url, payload);

    return response.response;
  },
  async getCellTowerInformationFromCoreId(coreId, startTime, endTime, virtualId = null) {
    const payload = {
      startDate: startTime,
      endDate: endTime,
    };

    let url = BASE_URL + "/fleet/radio/tower/" + coreId;
    if (virtualId) {
      url += "?virtual_id=" + encodeURIComponent(virtualId);
    }

    const response = await this.postNetworkItem(url, payload);

    return response.response;
  },
  async getCompanionDeviceMap(coreId, startTime, endTime, virtualId = null) {
    const payload = {
      startDate: startTime,
      endDate: endTime,
    };

    let url = BASE_URL + "/fleet/device-map/" + coreId;
    if (virtualId) {
      url += "?virtual_id=" + encodeURIComponent(virtualId);
    }

    const response = await this.postNetworkItem(url, payload);

    return response.response;
  },
  async getEventData(coreId, eventType, deviceType, skip, limit) {
    const url =
      BASE_URL +
      "/fleet/events/" +
      coreId +
      "?limit=" +
      String(limit) +
      "&skip=" +
      String(skip) +
      "&event_type=" +
      String(eventType) +
      "&device_type=" +
      String(deviceType);

    const response = await this.getNetworkItem(url);

    return response.response;
  },
  async getLastHarnessRecord(coreId, token) {
    const url = "https://mfgweb.alertlabs.com/api/v2/fleet/harness/" + coreId;

    let response = await fetch(url, {
      method: "GET",
      headers: {
        token: token,
      },
    });
    if (response.ok) {
      response = await response.json();
      return response.response;
    } else {
      throw new Error(response.statusText);
    }
  },
  async addNote(id, note, type, user_name) {
    const url = BASE_URL + "/notes/create";
    const timestamp = Date.now();
    let payload;
    if (type === "Device") {
      const coreID = id;
      payload = {
        coreID,
        note,
        type,
        timestamp,
        user_name,
      };
    } else if (type === "Location") {
      const locationID = id;
      payload = {
        locationID,
        note,
        type,
        timestamp,
        user_name,
      };
    } else {
      const userID = id;
      payload = {
        userID,
        note,
        type,
        timestamp,
        user_name,
      };
    }

    const response = await this.postNetworkItem(url, payload);
    return response;
  },
  async addBadBatchNote(deviceType, affectType, affectKey, affectNote) {
    const url = BASE_URL + "/fleet/badbatch/add";
    let payload;
    payload = {
      deviceType,
      affectType,
      affectKey,
      affectNote,
    };
    const response = await this.postNetworkItem(url, payload);
    return response;
  },
  async getBadBatchNotes(deviceType) {
    const url = BASE_URL + "/fleet/badbatch/get/" + deviceType;

    const response = await this.getNetworkItem(url);
    return response.response;
  },
  async getAllNotes(id, model_type, skip, take, important) {
    const url =
      BASE_URL + "/notes/get/" + id + "?model_type=" + model_type + "&skip=" + skip + "&take=" + take + "&important=" + important;

    const response = await this.getNetworkItem(url);
    return response.response;
  },
  async checkForTaggedNote(listOfCoreID, noteTag) {
    const url = BASE_URL + "/notes/waterkernel/status/" + noteTag;
    const payload = {
      coreIDs: listOfCoreID,
    };
    const response = await this.postNetworkItem(url, payload);
    return response.response;
  },
  async decryptData(coreID, data) {
    const url = BASE_URL + "/fleet/decrypt";
    const payload = {
      coreID: coreID,
      data: data,
    };
    const response = await this.postNetworkItem(url, payload);
    return response;
  },
  async getUserRoles(token) {
    const url = BASE_URL + "/user/data";

    let response = await fetch(url, {
      method: "GET",
      headers: {
        token: token,
      },
    });
    if (response.ok) {
      response = await response.json();
      return response.response;
    } else {
      throw new Error(response.statusText);
    }
  },
  async getNetworkItem(url) {
    try {
      let response = await fetch(url, {
        method: "GET",
      });

      handleSessionExpired(response);
      let mfgwebReturn = (response = await response.json());
      if (mfgwebReturn.result) {
        return mfgwebReturn;
      } else {
        throw new Error(mfgwebReturn.error);
      }
    } catch (error) {
      console.warn(
        "[status] WARN: unable to retrieve " + url + " from the network",
        error.message
      );
      throw error;
    }
  },
  async putNetworkItem(url) {
    try {
      let response = await fetch(url, {
        method: "PUT",
      });

      handleSessionExpired(response);
      let mfgwebReturn = (response = await response.json());
      if (mfgwebReturn.result) {
        return mfgwebReturn;
      } else {
        throw new Error(mfgwebReturn.error);
      }
    } catch (error) {
      console.warn(
        "[status] WARN: unable to retrieve " + url + " from the network",
        error.message
      );
      throw error;
    }
  },
  async deleteNetworkItem(url, payload) {
    try {
      let response = await fetch(url, {
        method: "DELETE",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
        },
      });

      handleSessionExpired(response);
      let mfgwebReturn = (response = await response.json());
      if (mfgwebReturn.result) {
        return mfgwebReturn;
      } else {
        throw new Error(mfgwebReturn.error);
      }
    } catch (error) {
      console.warn(
        "[status] WARN: unable to retrieve " + url + " from the network",
        error.message
      );
      throw error;
    }
  },
  async uploadNetworkItem(url, payload) {
    try {
      let response = await fetch(url, {
        method: "POST",
        body: payload,
      });

      handleSessionExpired(response);
      let mfgwebReturn = (response = await response.json());
      if (mfgwebReturn.result) {
        return mfgwebReturn;
      } else {
        throw new Error(mfgwebReturn.error);
      }
    } catch (error) {
      console.warn(
        "[status] WARN: unable to retrieve " + url + " from the network",
        error.message
      );
      return Promise.reject(error);
    }
  },
  async postNetworkItem(url, payload) {
    try {
      let response = await fetch(url, {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
        },
      });

      handleSessionExpired(response);
      let mfgwebReturn = (response = await response.json());
      if (mfgwebReturn.result) {
        return mfgwebReturn;
      } else {
        throw new Error(mfgwebReturn.error);
      }
    } catch (error) {
      console.warn(
        "[status] WARN: unable to retrieve " + url + " from the network",
        error.message
      );
      return Promise.reject(error);
    }
  },
  async patchNetworkItem(url, payload) {
    try {
      let response = await fetch(url, {
        method: "PATCH",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
        },
      });
      handleSessionExpired(response);
      let mfgwebReturn = (response = await response.json());
      if (mfgwebReturn.result) {
        return mfgwebReturn;
      } else {
        throw new Error(mfgwebReturn.error);
      }
    } catch (error) {
      console.warn(
        "[status] WARN: unable to retrieve " + url + " from the network",
        error.message
      );
      return Promise.reject(error);
    }
  },
  async getBlob(url) {
    try {
      let response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "text/csv",
        },
      });
      if (response.ok) {
        response = response.blob();
      } else {
        throw new Error(response.statusText);
      }
      return response;
    } catch (error) {
      console.warn(
        "[status] WARN: unable to retrieve " + url + " from the network",
        error.message
      );
      throw error;
    }
  },
};

export default FleetWebApi;
